import { CircularProgress, IconButton } from '@mui/material'
import CustomButton from '../Button'
import ClearIcon from '@mui/icons-material/Clear'
import CustomInput from '../TextInput'
import { useState } from 'react'

interface Props {
    title: string
    content: string
    onAction: (params: { rejectionReason: string }) => void
    onClose: () => void
    loading?: boolean
}

const RejectModal = ({ title, content, onAction, onClose, loading = false }: Props) => {
    const [reason, setReason] = useState<string>('')
    const [error, setError] = useState<string>('')

    const handleReject = () => {
        if (!validateInfo()) return

        onAction({ rejectionReason: reason })
    }

    const validateInfo = () => {
        const newErrors = reason === '' ? 'Falta ingresar la razón' : ''

        setError(newErrors)

        return newErrors === ''
    }

    return (
        <div className="flex flex-col w-[60vw] md:w-fit gap-2 md:gap-4">
            <div className="flex items-center">
                <label className="text-secondary font-semibold">{title}</label>
                <IconButton
                    onClick={onClose}
                    className="ml-auto p-0 text-primary"
                >
                    <ClearIcon />
                </IconButton>
            </div>
            <p className="text-sm md:text-base m-0">{content}</p>
            <CustomInput
                type="text"
                label="Razón de rechazo"
                multiline
                rows={2}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                errorText={error}
            />
            <CustomButton
                onClick={handleReject}
                className="h-[36px]"
                disabled={reason === '' || loading}
            >
                {loading ? (
                    <CircularProgress
                        size={24}
                        className="text-secondary"
                    />
                ) : (
                    'Aceptar'
                )}
            </CustomButton>
        </div>
    )
}

export default RejectModal
